/**
 * Offer + pad-vs-panties landing pages: lift the BIK WhatsApp FAB when a sticky
 * add-to-cart bar is visible so it does not overlap the CTA.
 */
(function () {
  'use strict';

  const DEFAULT_BOTTOM_PX = 82;
  const STICKY_GAP_PX = 16;
  const WA_BUTTON_SELECTOR = 'button[id*="bik-wa"][id$="-cta"]';

  function isLandingPage() {
    const layout = document.querySelector('.content-for-layout');
    if (!layout) return false;
    const classes = layout.className;
    if (classes.includes('hero-product-page')) return true;
    if (classes.includes('pad-vs-panties')) return true;
    return classes.includes('gopadfree-') && classes.includes('-offer');
  }

  if (!isLandingPage()) return;

  /** @returns {HTMLElement | null} */
  function getActiveStickyPanel() {
    const bundlePanel = document.querySelector('.bpb-sticky-panel.is-visible');
    if (bundlePanel instanceof HTMLElement) return bundlePanel;

    const offerPanel = document.querySelector('.sticky-atc-panel[data-stuck="true"]');
    if (offerPanel instanceof HTMLElement) return offerPanel;

    return null;
  }

  function getWaButtons() {
    return document.querySelectorAll(WA_BUTTON_SELECTOR);
  }

  function getTargetBottomPx() {
    const panel = getActiveStickyPanel();
    if (!panel) return DEFAULT_BOTTOM_PX;

    const panelHeight = Math.ceil(panel.getBoundingClientRect().height);
    return Math.max(DEFAULT_BOTTOM_PX + 1, panelHeight + STICKY_GAP_PX);
  }

  function applyOffset() {
    const panel = getActiveStickyPanel();
    const bottomPx = getTargetBottomPx();
    const isStickyVisible = Boolean(panel);

    document.body.classList.toggle('landing-sticky-atc-visible', isStickyVisible);
    document.documentElement.style.setProperty('--landing-wa-bottom', `${bottomPx}px`);

    getWaButtons().forEach((button) => {
      if (!(button instanceof HTMLElement)) return;

      if (isStickyVisible) {
        button.style.setProperty('bottom', `${bottomPx}px`, 'important');
      } else {
        button.style.removeProperty('bottom');
      }
    });
  }

  let scheduled = false;

  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      applyOffset();
    });
  }

  const observer = new MutationObserver(scheduleApply);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'data-stuck', 'style'],
  });

  window.addEventListener('resize', scheduleApply, { passive: true });
  window.addEventListener('scroll', scheduleApply, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleApply);
  } else {
    scheduleApply();
  }

  // BIK widget often injects after initial paint.
  window.setTimeout(scheduleApply, 500);
  window.setTimeout(scheduleApply, 1500);
  window.setTimeout(scheduleApply, 3000);
})();
